import PropTypes from 'prop-types';
import React from 'react';

import {
  Container, ContainerHeader, QuestionOrder, Title,
} from '../styles';

const TaskChart = (props) => {
  const {
    label,
    questionOrder,
    title,
  } = props;

  return (
    <Container>
      <ContainerHeader>
        <QuestionOrder>{`Question ${questionOrder + 1}`}</QuestionOrder>
        <Title>{`${label} (${title})`}</Title>
      </ContainerHeader>
    </Container>
  );
};

TaskChart.propTypes = {
  label: PropTypes.string.isRequired,
  questionOrder: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default TaskChart;
